export default __webpack_public_path__ + "static/media/I-2021.02feba28.pdf";